import { render, staticRenderFns } from "./CheckboxGreen.vue?vue&type=template&id=70233a28&"
import script from "./CheckboxGreen.vue?vue&type=script&lang=js&"
export * from "./CheckboxGreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports